
import { b64utoutf8 } from "jsrsasign";
import moment         from"moment";

export class AuthService {
  constructor ($http, $q, $location, API, ItCache, TLVCache, Bundle, StopWatch) {
    'ngInject';

    this.$http = $http;
    this.$q = $q;
    this.location = $location;
    this.API = API;
    this.ItCache = ItCache;
    this.TLVCache = TLVCache;
    this.Bundle = Bundle;
    this.StopWatch = StopWatch;

    this.handleUnauthorizedTimeout = null;
  }

  login(emailAddress, password, unlockCode) {
    return this.$http({
      method: 'POST',
      url: this.API.root + '/auth/session',
      headers: {
        'Content-Type': 'application/json'
      },
      data: {emailAddress, password, unlockCode}
    });
  }

  getSamlRequest() {
    return this.$http({
      method: 'GET',
      url: this.API.root + '/saml/authn',
    });
  }

  samlLogin(oneTimeToken) {
    return this.$http({
      method: 'POST',
      url: this.API.root + '/saml/login',
      data: {token: oneTimeToken}
    });
  }

  sendMailWithCodeAgain(emailAddress) {
    return this.$http({
      method: 'POST',
      url: this.API.root + '/auth/unlockCodes',
      headers: {
        'Content-Type': 'application/json'
      },
      data: { emailAddress }
    });
  }

  getUserToken(userId) {
    return this.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/admin/userToken',
      data: { userId }
    });
  }

  getRefreshToken(tokenFromLogin) {
    let browserId = navigator.userAgent.replace(/(\/|\s)/g, "");

    return this.$http({
      url: this.API.root + "/auth/devices/" + browserId + "/refresh-tokens",
      method: "POST",
      headers: {
        'Authorization': `Bearer ` +  tokenFromLogin
      }
    });
  }

  httpWithAuthToken(httpOptions, retry = 5) {
    return new Promise((resolve, reject) => {
      let requestInterval;
      const retryRequest = () => {
        clearInterval(requestInterval);
        this.getFreshUserCredentials().then((user) => {
          let options = angular.copy(httpOptions);
          options = {
            ...options,
            source: 'Web'
          };
          options.headers = options.headers || {};
          options.headers['Authorization'] = `Bearer ` + user.token;
  
          this.$http(options)
            .then((success) => {
              resolve(success);
            })
            .catch(error => {
              if (retry > 0 && (error.status === -1 || (error.message && error.message.includes('XHR error')))) {
                requestInterval = setInterval(retryRequest, 4000 / (retry));
                retry--;
              } else
                reject(error);
            });
        }, () => {
          this.handleUnauthorized();
        });
      };

      retryRequest();
    });
  }

  httpWithAuthTokenWithoutRefreshing(httpOptions) {
    const weUserCredentials = localStorage.getItem("ngStorage-roedl-session");
    const savedUserCredentials = weUserCredentials && angular.fromJson(localStorage.getItem("ngStorage-roedl-session"));
    const userToken = savedUserCredentials && savedUserCredentials.token;
    let options = angular.copy(httpOptions);
    options.headers = options.headers || {};
    if(userToken) {
      options.headers['Authorization'] = `Bearer ` + userToken;
    }
    return this.$http(options);
  }

  authorize() {
    var defer = this.$q.defer();
    this.getFreshUserCredentials().then(
      (user) => {
        if (window.DD_LOGS) {
          window.DD_LOGS.addLoggerGlobalContext('uid', user.id);
        }
        defer.resolve(user);
      },
      () => {
        defer.reject();
      }
    );
    return defer.promise;
  }

  authorizeAdmin() {
    var defer = this.$q.defer();
    this.getFreshUserCredentials().then((user) => {
      if(user && (user.isAdmin || user.isLocalAdmin)) {
        if(this.Bundle.getBundleType() === 'basic') {
          user.isAdmin = false;
          user.isLocalAdmin = true;
        }
        if (window.DD_LOGS) {
          window.DD_LOGS.addLoggerGlobalContext('uid', user.id);
        }
        defer.resolve(user);
      } {
        defer.reject();
      }
    });
    return defer.promise;
  }

  authorizePowerUser() {
    var defer = this.$q.defer();
    this.getFreshUserCredentials().then((user) => {
      if(user && user.isPowerUser) {
        if (window.DD_LOGS) {
          window.DD_LOGS.addLoggerGlobalContext('uid', user.id);
        }
        defer.resolve(user);
      } {
        defer.reject();
      }
    });
    return defer.promise;
  }

  setupLogin(data) {
    var token = data.token;
    var dataPart = token.split(".")[1];
    var json = decodeURIComponent(b64utoutf8( dataPart ));
    var sessionData = angular.fromJson(json);
    sessionData.token = data.token;
    localStorage.setItem("ngStorage-roedl-session", angular.toJson(sessionData));
  }

  setupRefreshToken(token) {
    localStorage.setItem("ngStorage-roedl-refresh-token", angular.toJson(token.data.value));
  }

  getFreshUserCredentials(force) {
    var defer = this.$q.defer();
    const weUserCredentials = localStorage.getItem("ngStorage-roedl-session");
    const savedUserCredentials = weUserCredentials && angular.fromJson(localStorage.getItem("ngStorage-roedl-session"));
    const weHaveValidUserCredentials = savedUserCredentials && ((savedUserCredentials.exp * 1000 > (moment.now() + 60000)) || !savedUserCredentials.exp) && !force; // time now + 1min or old jwt
    const weHaveRefreshToken = localStorage.getItem("ngStorage-roedl-refresh-token");

    const updateSessionWithFeatureFlagsAndSetupCredentials = (sessionInfo) => {
      return this.getFeatureFlags().then(({data}) => {
        if (!sessionInfo.preferences || sessionInfo.preferences === null)
          sessionInfo.preferences = {};
        sessionInfo.preferences.featureFlags = data;
        localStorage.setItem("ngStorage-roedl-session", angular.toJson(sessionInfo));
        defer.resolve(sessionInfo);
      });
    };

    const tryLoggingInWithRefreshTokenAndSetupCredentials = () => {
      this.tryLoggingInWithRefreshToken().then((success) => {
        return updateSessionWithFeatureFlagsAndSetupCredentials(success);
      }, () => {
        defer.reject("Couldn't login with refresh token.");
      });
    };

    if(weHaveValidUserCredentials) {
      if(!weHaveRefreshToken) {
        //zrobic RT
        //pobrać krócej istniejące JWT
        this.getRefreshToken(savedUserCredentials.token).then((refreshToken) => {
          this.setupRefreshToken(refreshToken);
          tryLoggingInWithRefreshTokenAndSetupCredentials();
        }, (errorRefreshingToken) => {
          defer.reject("Couldn't create refresh token.", errorRefreshingToken);
        });
      } else {
        defer.resolve(savedUserCredentials);
      }
    } else {
      if(weHaveRefreshToken) {
        tryLoggingInWithRefreshTokenAndSetupCredentials();
      } else {
        defer.reject("No Refresh Token");
      }
    }
    return defer.promise;
  }

  getFeatureFlags() {
    return this.httpWithAuthToken({
      url: this.API.root + "/users/me/featureFlags"
    });
  }

  setFeatureFlagsToLocaleStorage(user) {
    return this.getFeatureFlags().then(({data}) => {
      if (user.preferences === null)
        user.preferences = {};
      user.preferences.featureFlags = data;
      localStorage.setItem("ngStorage-roedl-session", angular.toJson(user));
      return user;
    });
  }

  tryLoggingInWithRefreshToken() {
    const refreshToken = angular.fromJson(localStorage.getItem("ngStorage-roedl-refresh-token"));
    return this.$http({
      url: this.API.root + "/auth/session/refresh-tokens",
      method: "POST",
      data: {
        value: refreshToken
      }
    }).then((loginSuccess) => {
      var token = loginSuccess.data.token;
      var dataPart = token.split(".")[1];
      var json = decodeURIComponent(b64utoutf8( dataPart ));
      var sessionData = angular.fromJson(json);
      sessionData.token = loginSuccess.data.token;
      localStorage.setItem("ngStorage-roedl-session", angular.toJson(sessionData));

      return sessionData;
    });
  }

  getPreferences() {
    return this.getFreshUserCredentials().then((user) => {
      return user.preferences || {};
    });
  }

  getCustomSetupExchangeRate() {
    return this.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/currencies/settings'
    });
  }

  patchCustomSetupExchangeRate(data) {
    return this.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/currencies/settings',
      data: data
    });
  }

  patchPreferences(objectToPatchPreferencesWith) {
    var defer = this.$q.defer();
    this.httpWithAuthToken({
      method: 'PUT',
      url: this.API.root + '/users/me/preferences',
      data: angular.copy(objectToPatchPreferencesWith)
    }).then((success) => {
      this.setupLogin(success.data);
      defer.resolve(success);
    }, (error) => {
      defer.reject(error);
    });
    return defer.promise;
  }

  getMyPreferences(user) {
    return this.$http({
      method: 'GET',
      url: this.API.root + '/users/me/preferences',
      headers: {
        Authorization: 'Bearer ' + user.token
      }
    });
  }

  cleanBrowser(handleUnauthorized) {
    localStorage.removeItem("ngStorage-roedl-session");
    localStorage.removeItem("ngStorage-roedl-refresh-token");

    if (!handleUnauthorized) {
      localStorage.removeItem("roedl-time-started");
      localStorage.removeItem("roedl-time-started-pg");
      localStorage.removeItem("roedl-time-started-interruption");
      localStorage.removeItem("roedl-time-started-client-id");
    }

    localStorage.removeItem("roedl-admin-clients");
    localStorage.removeItem("roedl-admin-countries");
    localStorage.removeItem("roedl-admin-groupCountryConfigurations");
    localStorage.removeItem("roedl-admin-teams");
    localStorage.removeItem("roedl-admin-users");
    localStorage.removeItem("roedl-time-duration-interruption");
    this.ItCache.clear();
    this.TLVCache.clear();
    sessionStorage.removeItem("roedl-tl-date-end");
    sessionStorage.removeItem("roedl-tl-date-start");
    sessionStorage.removeItem("roedl-tl-date-pv");
    sessionStorage.removeItem("roedl-tl-filtered-users");
    sessionStorage.removeItem("roedl-tl-selected-columns");

    if (!handleUnauthorized) {
      this.counter = this.StopWatch.counters.normal;
      this.StopWatch.stopAndclearCounter(this.counter);
    }
  }

  handleUnauthorized(){
    clearTimeout(this.handleUnauthorizedTimeout);

    this.handleUnauthorizedTimeout = setTimeout(() => {
      // eslint-disable-next-line no-console
      console.warn("handleUnauthorized(): " + Error().stack);
      this.cleanBrowser(true);
      window.location.replace(`/login?next=${encodeURIComponent(this.location.url())}`);
      clearTimeout(this.handleUnauthorizedTimeout);
    }, 50);
  }

  logout(){
    // eslint-disable-next-line no-console
    console.info("logout()");
    this.cleanBrowser();
    this.location.path("/login");
  }

  sendPasswordResetLink(emailAddress) {
    return this.$http({
      method: 'POST',
      url: this.API.root + '/auth/password',
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        emailAddress,
        template: {
          subjectTemplate: "KliX web — Password Reset",
          bodyTemplate: `Hello { fullName },\n\nIn order to reset your password, please follow this link below and set new password.\n ${window.location.href}/{ resetToken } \n\nBest Regards, KliX Team`
        }
      }
    });
  }

  setNewPassword(resetToken, password) {
    return this.$http({
      method: 'PATCH',
      url: this.API.root + '/auth/password',
      headers: {
        'Content-Type': 'application/json'
      },
      data: {resetToken, password}
    });
  }

  resetPassword(password) {
    return this.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/auth/password',
      data: { password }
    });
  }

  validatePassword(password, fullName) {
    const forbidden = ["rodl", "rödl", "roedl", "partner"];
    const passLoCase = password.toLowerCase();
    const forbiddenInPass = forbidden.filter(f => passLoCase.indexOf(f) >= 0);

    const doNotUseThese = fullName.split(" ")
      .filter(n => n.length > 1)
      .map(n => n.toLowerCase())
      .filter(n => passLoCase.indexOf(n) >= 0)
      .concat(forbiddenInPass);

    return {
      isValid: doNotUseThese.length == 0,
      message: doNotUseThese.reduce((acc, curr) => acc + " " + curr, "")
    };
  }

  getLatestTermsOfUse() {
    return this.$http({
      method: 'GET',
      url: this.API.root + '/latestTermsOfUse'
    });
  }

  acceptTermsOfUse() {
    return this.httpWithAuthToken({
      method: 'POST',
      url: this.API.root + '/latestTermsOfUse'
    });
  }

  getLicenseAgreementById(id) {
    return this.$http({
      method: 'GET',
      url: this.API.root + '/license-agreement-forms/' + id
    });
  }

  getLicenseAgreementAttachments(id) {
    return this.$http({
      method: 'GET',
      url: this.API.root + '/license-agreement-forms/' + id + '/attachments'
    });
  }

  uploadLicenseAgreementFiles(file, id) {
    var fd = new FormData();
    fd.append('file', file);
    var url = this.API.root + '/license-agreement-forms/' + id + '/' + encodeURIComponent(file.name);
    return this.$http({
      method: 'POST',
      url: url
    }).then((response) => {
      return this.$http.put(response.data.url, fd, {
        headers: {
          'Content-Type': undefined
        }
      });
    });
  }

  sendLicenseAgreementForm(id, agreement) {
    return this.$http({
      method: 'POST',
      url: this.API.root + '/license-agreements/' + id + '/form',
      data: agreement
    });
  }

  getLicenseAgreementPdf() {
    return this.$http({
      method: 'GET',
      url: this.API.root + '/license-agreement-file',
      headers: {
        'Content-Type': 'application/pdf'
      },
      responseType: 'arraybuffer'
    });
  }

  getDocsPage() {
    return this.httpWithAuthToken({
      method: 'GET',
      url: this.API.root + '/docs'
    });
  }

  getIdpUrl() {
    return this.$http({
      method: 'GET',
      url: this.API.root + '/saml/idp-url'
    });
  }
}
